import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTOWordWithRelatedWords extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORD_WITH_RELATED_WORDS;

  /*
   * INSTANCE FIELDS
   */

  word_english!: string;

  synonyms: string[];
  antonyms: string[];

  /*
   * METHODS
   */

  constructor() {
    super();

    this.synonyms = [];
    this.antonyms = [];
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.word_english);
  }

  is_empty(): boolean {
    return this.synonyms.is_empty() && this.antonyms.is_empty();
  }
}
